export default {"src":"/_next/static/media/Custom.d9468aca.svg","height":114,"width":199};